import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Toaster } from 'vue-sonner';
    import { LoaderCircle, Check, CircleCheck } from 'lucide-vue-next';

export default /*@__PURE__*/_defineComponent({
  __name: 'AppToaster',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Toaster), {
    position: "top-right",
    expand: "",
    "visible-toasts": 10,
    toastOptions: {
            unstyled: true,
            classes: {
                toast: 'flex w-[var(--width)] items-center gap-2 rounded border p-4 text-xs text-white shadow-md font-sans',
                content: 'flex flex-col gap-1',
                description: 'font-bold text-sm',
                success: 'bg-secondary/80 border-secondary',
                error: 'bg-destructive/80 border-destructive',
            },
        }
  }, {
    "loading-icon": _withCtx(() => [
      _createVNode(_unref(LoaderCircle), { class: "size-4.5 animate-spin text-white" })
    ]),
    "success-icon": _withCtx(() => [
      _createVNode(_unref(CircleCheck), { class: "size-4.5 text-white" })
    ]),
    _: 1
  }))
}
}

})